import Section from '../Section';

export default class CollectionHeader extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

  }
}